import { Component, Host, h, Prop } from "@stencil/core";
import SyncPrice from "@apis/model/sync-price";
import state from "@stores/price.store";

@Component({
  tag: "bcp-price",
  styleUrl: "bcp-price.scss",
  shadow: true,
})
export class Price {
  @Prop() productId: string;
  @Prop() fallback: string;
  @Prop() noPriceText?: string;

  render() {
    const syncPrices: SyncPrice[] = state
      .get("prices")
      ?.get(this.productId)?.syncPrice;
    const selectedPrice = state
      .get("prices")
      ?.get(this.productId)?.selectedSyncPrice;
    const timeout = state.get("timeoutPrices");
    const loading = state.get("loadingPrices");
    const price = syncPrices?.find(
      (price) => price.name === selectedPrice
    )?.formattedValue;
    const priceValue = syncPrices?.find(
      (price) => price.name === selectedPrice
    )?.value;
    return (
      <Host>
        {priceValue === 0 && this.noPriceText ? (
          <span>{this.noPriceText}</span>
        ) : (
          price
        )}
        {!price && !this.fallback && this.noPriceText && (
          <p class="no-price">{this.noPriceText}</p>
        )}
        {timeout && this.fallback}
        {loading && <span>&nbsp;</span>}
      </Host>
    );
  }
}
